import React, { useState } from "react";
import ChatPduliAIKonseli from "./ChatPduliAIKonseli";
import PDFViewer from "./PDFViewer";
import { classNames } from "../../../../general/functions/propsComponent";

const MENU = [
  // {
  //   idView: 1,
  //   name: "Riwayat Chat",
  //   comp: () => <ChatPduliAIKonseli />,
  // },
  {
    idView: 2,
    name: "Dokumen",

    comp: ({ src }) => <PDFViewer src={src} />,
  },
];

export default function OtherSecctionData(props) {
  const { data } = props;
  const [idView, setIdView] = useState(2);
  const SubView = () => {
    return MENU.find((x) => x.idView == idView).comp({ src: data?.dokumen });
  };

  const changeView = (v) => {
    setIdView(v);
  };

  return (
    <div className="hidden sm:flex flex-1 h-screen  flex-col">
      <div className="bg-secondary-500 flex gap-2 px-4 ">
        {MENU.map((x) => {
          return (
            <button
              className={classNames(
                idView == x.idView && "border-b-4 border-primary-600",
                " text-white  px-3 py-4 text-sm font-medium"
              )}
              onClick={(e) => {
                e.preventDefault();
                changeView(x.idView);
              }}
            >
              {x.name}
            </button>
          );
        })}
      </div>
      <div className="h-full flex-1">{SubView()}</div>
    </div>
  );
}
